import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import menu from './modules/menu.js';
import feedback from './modules/feedback.js';
import portfolios from './modules/portfolios.js';
import quotes from './modules/quotes.js';
import auth from './modules/auth.js';
import chat from './modules/chat.js';
import chatmessage from './modules/chatmessage.js';
import usersets from './modules/usersets.js';
import layout from './modules/layout.js';
import tradingspecs from './modules/tradingspecs.js';
import accountstat from './modules/accountstat.js';
import positions from './modules/positions.js';
import closPositions from './modules/closed_positions.js';
import closSummary from './modules/closed_pos_summary.js';
import color from './modules/color-theme.js';
import api from './modules/api.js';
import news from './modules/news.js';
import blog from './modules/blog.js';
import accountevents from './modules/account-events.js';
import ready from './modules/ready-data.js';

export const store = new Vuex.Store({
    modules: {
        menu,
        feedback,
        portfolios,
        quotes,
        auth,
        chat,
        chatmessage,
        usersets,
        layout,
        tradingspecs,
        accountstat,
        positions,
        closPositions,
        closSummary,
        color,
        api,
        accountevents,
        news,
        blog,
        ready
    },
    strict: process.env.NODE_ENT !== 'production'
})